import React from 'react';

import { ClientList } from 'containers/Client';

function Profiles() {
  return (<ClientList />);
}

export default Profiles;
